export function spaceGenerator(number = 0) {
    let res = '';
    for (let i = 0; i < number; i++) {
        res += ' ';
    }

    return res;
}